"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("circle", {
  cx: "12",
  cy: "18",
  r: "2"
}), 'Wifi1BarRounded');